import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { HotKeys } from 'react-hotkeys';
import Loader from 'react-loader-advanced';

import _get from 'lodash/get';
import _trim from 'lodash/trim';
import _pick from 'lodash/pick';

import {
  updateDictionary,
  checkDictionaryName,
} from 'store/services/dictionaries/actions';

import InspectButton from 'components/InspectButton';
import Form, { FormGroupField, FormGroupTextarea } from 'components/Form';
import InspectFooter from 'components/InspectFooter';
import { dictionaryType } from 'types';
import FORM_NAMES from 'constants/formNames';

import validate from './utils';

import './style.scss';

const HOTKEYS_MAP = {
  save: 'alt+s',
};

export class DictionaryInspectGeneral extends Component {
  static propTypes = {
    // eslint-disable-next-line react/no-unused-prop-types
    dictionary: dictionaryType.isRequired,
    isArchived: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func,

    // REDUX-FORM:
    valid: PropTypes.bool.isRequired,
    dirty: PropTypes.bool.isRequired,
    submit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func.isRequired,
  };

  keyHandlers = {
    save: e => {
      // Prevents default behavior for Alt+S combination
      e.preventDefault();

      const { valid, dirty, submit } = this.props;

      if (valid && dirty) {
        submit();
      }
    },
  };

  render() {
    const {
      dirty,
      valid,
      submitting,
      isArchived,
      onSubmit,
      handleSubmit,
    } = this.props;

    return (
      <HotKeys keyMap={HOTKEYS_MAP} handlers={this.keyHandlers}>
        <Loader
          show={submitting}
          message="Updating..."
          foregroundStyle={{ color: '#555555' }}
          backgroundStyle={{ backgroundColor: 'rgba(255, 255, 255, .67)' }}
        >
          <Form
            styleName="edit-dictionary-form"
            onSubmit={handleSubmit(onSubmit)}
          >
            <Field
              autoFocus
              component={FormGroupField}
              type="text"
              normalize={_trim}
              name="name"
              label="DICTIONARY NAME"
              placeholder="Please type a name for the dictionary"
              disabled={isArchived}
              data-test="name"
            />

            <Field
              component={FormGroupTextarea}
              name="description"
              label="DESCRIPTION"
              placeholder="Dictionary description"
              disabled={isArchived}
              data-test="description"
            />

            <InspectFooter>
              <InspectButton
                type="submit"
                isFooter
                isSave
                data-test="save-dictionary"
                disabled={isArchived || submitting || !dirty || !valid}
              >
                Save
              </InspectButton>
            </InspectFooter>
          </Form>
        </Loader>
      </HotKeys>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  initialValues: _pick(ownProps.dictionary, ['name', 'description']),
  isArchived: _get(ownProps.dictionary, 'archived', false),
});

const mapDispatchToProps = dispatch => ({
  onSubmit: bindActionCreators(updateDictionary, dispatch),
  onCheckDictionaryName: bindActionCreators(checkDictionaryName, dispatch),
});

const asyncValidate = (formProps, dispatch, props) =>
  props.onCheckDictionaryName('name', formProps.name, props.dictionary.id);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  reduxForm({
    asyncValidate,
    validate,
    asyncChangeFields: ['name'],
    enableReinitialize: true,
    form: FORM_NAMES.DICTIONARIES.INSPECT,
    touchOnBlur: false,
    touchOnChange: true,
  })(DictionaryInspectGeneral),
);
